import { DescriptiveError, DescriptiveErrorOptions } from '../../error/DescriptiveError';
import { CustomRedirectUrlQueryParams } from '../redirect/redirectUrl';

interface CustomRedirectUrlParamsNotFoundErrorOptions extends Omit<DescriptiveErrorOptions, 'message'> {
  missingKeys: (keyof CustomRedirectUrlQueryParams)[];
}

export class CustomRedirectUrlParamsNotFoundError extends DescriptiveError {
  constructor({ missingKeys = [], ...options }: CustomRedirectUrlParamsNotFoundErrorOptions) {
    super({
      ...options,
      message: `Missing expected custom redirect URL query params${missingKeys.length ? `: ${missingKeys.join(', ')}` : ''}`,
    });
    this.name = 'CustomRedirectUrlParamsNotFoundError';
  }
}
